import * as React from 'react';

import classNames from 'classnames';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import { StyleSheet, color, css } from '@coursera/coursera-ui';

import { sourceSansPro, stylusBreakpoints } from 'bundles/front-page/constants/rebrand';
import LazyImgix from 'bundles/page/components/shared/LazyImgix';

const styles = StyleSheet.create({
  socialProofItemContainer: {
    textAlign: 'center',
  },
  contentContainer: {
    color: color.primaryText,
    display: 'block',
    margin: '0 auto',
    maxWidth: '270px',
  },
  imageContainer: {
    display: 'inline-block',
    height: '210px',
    maxWidth: '270px',
  },
  actualImage: {
    width: '100%',
  },
  name: {
    fontFamily: sourceSansPro,
    fontSize: '28px',
    lineHeight: '36px',
    fontWeight: 600,
    color: '#382D8B',
    [stylusBreakpoints.tabletOrSmaller]: {
      fontSize: '24px',
      lineHeight: '32px',
    },
    [stylusBreakpoints.phoneOrSmaller]: {
      fontSize: '24px',
      lineHeight: '32px',
    },
  },
  socialProofTitle: {
    fontFamily: sourceSansPro,
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 600,
    color: color.primaryText,
    [stylusBreakpoints.tabletOrSmaller]: {
      fontSize: '16px',
      lineHeight: '24px',
    },
    [stylusBreakpoints.phoneOrSmaller]: {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  socialProofSubtitle: {
    fontFamily: sourceSansPro,
    fontSize: '16px',
    lineHeight: '24px',
    color: color.primaryText,
    [stylusBreakpoints.tabletOrSmaller]: {
      fontSize: '16px',
      lineHeight: '24px',
    },
    [stylusBreakpoints.phoneOrSmaller]: {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  body: {
    fontFamily: sourceSansPro,
    fontSize: '20px',
    lineHeight: '28px',
    color: color.primaryText,
    [stylusBreakpoints.tabletOrSmaller]: {
      fontSize: '16px',
      lineHeight: '24px',
    },
    [stylusBreakpoints.phoneOrSmaller]: {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  separator: {
    backgroundColor: color.primary,
    display: 'inline-block',
    height: '2px',
    marginBottom: '20px',
    marginTop: '20px',
    width: '69px',
  },
});

type Props = {
  name: string;
  title: string;
  subtitle?: string;
  body: string;
  rebrandImageUrl: string;
};

const SocialProofItem = ({ name, title, subtitle, body, rebrandImageUrl }: Props) => {
  const socialProofItemRootClasses = classNames(
    css(styles.socialProofItemContainer).className,
    'rc-SocialProofItemRedesign'
  );

  return (
    <div className={socialProofItemRootClasses}>
      <div {...css(styles.contentContainer)}>
        <div {...css(styles.imageContainer)}>
          <LazyImgix
            className={css(styles.actualImage).className}
            src={rebrandImageUrl}
            maxWidth={202}
            maxHeight={202}
            alt=""
          />
        </div>
        <h3 {...css(styles.name)}>{name}</h3>
        <div {...css(styles.socialProofTitle)}>{title}</div>
        {subtitle !== undefined && <div {...css(styles.socialProofSubtitle)}>{subtitle}</div>}

        <div {...css(styles.separator)} />

        <p {...css(styles.body)}>
          <FormattedHTMLMessage message={body} tagName="span" />
        </p>
      </div>
    </div>
  );
};

export default SocialProofItem;
